import React from 'react';
import { useDispatch } from 'react-redux';
import SecondaryContainedButton from '../../SecondaryContainedButton';
import { nextStep } from '../actions';
import { useQuestionnaireData } from '../context';

const NextButton = () => {
  const dispatch = useDispatch();
  const { beforeNextStepAction, changeStepAction } = useQuestionnaireData();
  const onClick = () => {
    dispatch(nextStep({ beforeNextStepAction, changeStepAction }));
  };
  return <SecondaryContainedButton label="button.next.label" onClick={onClick} />;
};

export default NextButton;
